import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { Routes, Route, useNavigate } from "react-router-dom";

import Pagedialog from "../components/Pagedialog";
import Start from "../pages/Start";
import Imprint from "../pages/Imprint";
import Datasecurity from "../pages/Datasecurity";
import UserManual from "../pages/UserManual";

export default function Pages() {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const closeRouteDialog = () => {
    navigate("/");
  };

  return (
    <>
      <Pagedialog
        title="FLIK-Suche"
        open={appContext.infoDialogOpen}
        handleClose={() => {
          appContext.setInfoDialogOpen(false);
        }}
      >
        <Start />
      </Pagedialog>
      <Routes>
        <Route
          path="/benutzerhandbuch"
          element={
            <Pagedialog
              title="Benutzerhandbuch"
              open={true}
              handleClose={closeRouteDialog}
            >
              <UserManual />
            </Pagedialog>
          }
        />
        <Route
          path="/impressum"
          element={
            <Pagedialog
              title="Impressum"
              open={true}
              handleClose={closeRouteDialog}
            >
              <Imprint />
            </Pagedialog>
          }
        />
        <Route
          path="/datenschutz"
          element={
            <Pagedialog
              title="Datenschutz"
              open={true}
              handleClose={closeRouteDialog}
            >
              <Datasecurity />
            </Pagedialog>
          }
        />
      </Routes>
    </>
  );
}
